<template>
    <div class="recurrence-editor-container">
        <el-form ref="roleForm" inline>
            <el-row :gutter="10">
                <el-col :span="24" class="mb-4">
                    <el-select
                        v-model="value.scheduleUsers"
                        value-key="id"
                        class="w-100"
                        multiple
                        collapse-tags
                        clearable
                        filterable
                        placeholder="Schedule Recipients"
                        reserve-keyword
                        popper-class="report-schedule-users-select-popper"
                        :loading="usersLoading"
                        @focus="getUsers"
                    >
                        <template v-if="value.scheduleUsers.length && !users.length">
                            <el-option
                                v-for="(user, idx) in value.scheduleUsers"
                                :key="idx"
                                :value="user"
                                :label="`${user.first_name} ${user.last_name} (${user.email})`"
                                class="font-12"
                            >
                                <span style="float: left">{{ user.first_name }} {{ user.last_name }}</span>
                                <span style="float: right; padding-right: 20px; font-size: 10px">{{ user.email }}</span>
                            </el-option>
                        </template>

                        <el-option-group v-if="filterUsers('administrator').length" label="Administrators">
                            <template v-for="user in filterUsers('administrator')">
                                <el-option
                                    :key="user.id"
                                    :label="`${user.full_name} (${user.email})`"
                                    :value="user"
                                    class="font-12 pl-4 pr-5"
                                >
                                    <span class="float-left">{{ user.full_name }}</span>
                                    <span class="float-right font-10">{{ user.email }}</span>
                                </el-option>
                            </template>
                        </el-option-group>
                        <el-option-group v-if="filterUsers('manager').length" label="Managers">
                            <template v-for="user in filterUsers('manager')">
                                <el-option
                                    :key="user.id"
                                    :label="`${user.full_name} (${user.email})`"
                                    :value="user"
                                    class="font-12 pl-4 pr-5"
                                >
                                    <span class="float-left">{{ user.full_name }}</span>
                                    <span class="float-right font-10">{{ user.email }}</span>
                                </el-option>
                            </template>
                        </el-option-group>
                        <el-option-group v-if="filterUsers('broker').length" label="Brokers">
                            <template v-for="user in filterUsers('broker')">
                                <el-option
                                    :key="user.id"
                                    :label="`${user.full_name} (${user.email})`"
                                    :value="user"
                                    class="font-12 pl-4 pr-5"
                                >
                                    <span class="float-left">{{ user.full_name }}</span>
                                    <span class="float-right font-10">{{ user.email }}</span>
                                </el-option>
                            </template>
                        </el-option-group>
                        <el-option-group v-if="filterUsers('referrer').length" label="Referrers">
                            <template v-for="user in filterUsers('referrer')">
                                <el-option
                                    :key="user.id"
                                    :label="`${user.full_name} (${user.email})`"
                                    :value="user"
                                    class="font-12 pl-4 pr-5"
                                >
                                    <span class="float-left">{{ user.full_name }}</span>
                                    <span class="float-right font-10">{{ user.email }}</span>
                                </el-option>
                            </template>
                        </el-option-group>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="Repeat">
                        <el-select v-model="value.repeatOption.type" @change="updateRepeatOption">
                            <el-option label="Every Day" value="every_day"></el-option>
                            <el-option label="Every Week" value="every_week"></el-option>
                            <el-option label="Every Month" value="every_month"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="At" prop="value.repeatAt" class="mr-0">
                        <el-time-select
                            v-model="value.repeatAt"
                            :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '23:45',
                            }"
                            placeholder="Select time"
                            @change="updateRepeatAt"
                        ></el-time-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item v-if="value.repeatOption.type === 'every_week'" label="Repeat On">
                        <label v-for="date in weekDayCheckBox" :key="date.value">
                            <input
                                type="checkbox"
                                :value="date.value"
                                v-model="everyWeekPicker"
                                @change="updateWeekDayOption($event)"
                            />
                            <span>{{ date.name }}</span>
                        </label>
                    </el-form-item>
                    <el-form-item v-if="value.repeatOption.type === 'every_month'" label="Repeat On">
                        <el-date-picker
                            v-model="value.repeatOption.dayOfMonth"
                            value-format="d"
                            format="d"
                            type="date"
                            :picker-options="{ firstDayOfWeek: 1 }"
                            placeholder="Pick a day"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="Show Summary Row?">
                       <el-checkbox v-model="value.showSummary">append summary row to end of document.</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div>
            {{ this.toString }}
        </div>
    </div>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            users: [],
            usersLoading: false,
            scheduleRecipients: [],
            toString: "",
            everyWeekPicker: this.value.repeatOption.everyWeekPicker,
            endsPicked: this.value.endsPicked,
            weekDayCheckBox: [
                {
                    name: "Mon",
                    value: "1",
                    full_name: "Monday",
                },
                {
                    name: "Tue",
                    value: "2",
                    full_name: "Tuesday",
                },
                {
                    name: "Wed",
                    value: "3",
                    full_name: "Wednesday",
                },
                {
                    name: "Thu",
                    value: "4",
                    full_name: "Thursday",
                },
                {
                    name: "Fri",
                    value: "5",
                    full_name: "Friday",
                },
                {
                    name: "Sat",
                    value: "6",
                    full_name: "Saturday",
                },
                {
                    name: "Sun",
                    value: "7",
                    full_name: "Sunday",
                },
            ],
        }
    },
    computed: {
        ajax() {
            if (this.isMaster) {
                return this.$admin;
            } else {
                return this.$tenant;
            }
        },
        isTenant() {
            return !this.isMaster
        },
        isMaster() {
            return _.has(window, "MasterGlobals")
        },
    },
    methods: {
        emitData(data) {
            this.$emit("input", data)
            this.toString = this.generateString(data)
        },
        generateString(data) {
            let str = ""
            switch (data.repeatOption.type) {
                case "every_week":
                    let hash = {
                        1: "Monday",
                        2: "Tuesday",
                        3: "Wednesday",
                        4: "Thursday",
                        5: "Friday",
                        6: "Saturday",
                        7: "Sunday",
                    }

                    str += "Weekly from "
                    let weekNames = data.repeatOption.everyWeekPicker
                        .map(function (v) {
                            return hash[v]
                        })
                        .join(", ")

                    str += weekNames
                    str += " at " + data.repeatAt
                    break

                case "every_day":
                    str = "Everyday  at " + data.repeatAt
                    break
            }
            return str
        },
        updateWeekDayOption(event) {
            let data = { ...this.value }
            let index = data.repeatOption.everyWeekPicker.indexOf(event.target.value)
            if (!event.target.checked) {
                data.repeatOption.everyWeekPicker.splice(index, 1)
            }
            if (index === -1 && event.target.checked) {
                data.repeatOption.everyWeekPicker.push(event.target.value)
            }
            data.repeatOption.everyWeekPicker.sort()
            this.emitData(data)
        },
        updateRepeatAt(value) {
            let data = { ...this.value }
            data.repeatAt = value
            this.emitData(data)
        },
        updateRepeatOption(value) {
            if (value != "every_week") {
                this.everyWeekPicker = ["1", "2", "3", "4", "5", "6", "7"]
                this.value.repeatOption.everyWeekPicker = this.everyWeekPicker
            }
            let data = { ...this.value }
            data.repeatOption.type = value
            this.emitData(data)
        },
        updateEndsPicked(event) {
            let data = { ...this.value }
            data.endsPicked = event.target.value
            this.emitData(data)
        },
        async getUsers() {
            if (this.users.length) return

            this.usersLoading = true

            const routeName = this.isMaster ? 'master-users' : 'tenant-users';

            try {
                await this.ajax.get(`/api/${routeName}`)
                    .then((res) => {
                        this.users = res && res.data ? res.data : []
                    })
                    .finally(() => {
                        this.usersLoading = false
                    })
            } catch (err) {
                this.usersLoading = false
                console.error(err)
            }
        },
        filterUsers(roleName) {
            return this.users.filter(
                (user) => !!user.roles.filter(
                    (role) => role.name === roleName
                ).length
            );
        },
    },
    created() {
        this.toString = this.generateString(this.value)
    },
    mounted() {},
}
</script>

<style>
.report-builder .modal-container {
    z-index: 10;
}
.recurrence-editor-container .el-select .el-input {
    padding-bottom: 2px;
}
.recurrence-editor-container input.el-input__inner::placeholder,
.recurrence-editor-container input.el-select__input.is-mini::placeholder {
    font-size: 13px !important;
}

.report-schedule-users-select-popper .el-select-group__title {
    font-size: 14px !important;
    color: #284da5 !important;
}
</style>

<style scoped>
input[type="checkbox"] {
    display: none;
}

label :checked + span {
    background: #66bb6a;
    color: white;
}

label span {
    display: inline-block;
    background: lightgrey;
    height: 3em;
    width: 3em;
    line-height: 3em;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
    margin-right: 2px;
}

.round {
    position: relative;
}

.round label {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    height: 28px;
    left: 0;
    position: absolute;
    top: 0;
    width: 28px;
}

.round input[type="checkbox"] {
    visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
    background-color: #66bb6a;
    border-color: #66bb6a;
}

.round input[type="checkbox"]:checked + label:after {
    opacity: 1;
}
</style>
